import { getLocale } from '@umijs/max';
import en from './en-US';

/**
 * 界面文案翻译（M7-06）。代码里直接写简体中文原文作键：`t('保存')`、`t('共 {0} 条', [n])`，
 * 英文界面从 `en-US.ts` 取译文，缺译文时回落到中文原文。产品语言为简体中文与英文。
 *
 * 切换语言会刷新页面，所以模块级的标签常量（如状态文案表）也按当前语言取值。
 */
export function t(text: string, args?: readonly unknown[]): string {
  let out = text;
  try {
    if (getLocale() === 'en-US') out = en[text] ?? text;
  } catch {
    // no locale context (unit tests, early boot): keep the source text
  }
  if (!args || args.length === 0) return out;
  return out.replace(/\{(\d+)\}/g, (m, i) => {
    const v = args[Number(i)];
    return v === undefined || v === null ? '' : String(v);
  });
}

/** 发给控制台服务的界面语言（Accept-Language），服务端据此返回对应语言的提示与报错。 */
export function uiLanguage(): 'en-US' | 'zh-CN' {
  try {
    return getLocale() === 'en-US' ? 'en-US' : 'zh-CN';
  } catch {
    return 'zh-CN';
  }
}

/** 列表分隔符：中文用顿号，英文用逗号。 */
export const listSep = () => (uiLanguage() === 'en-US' ? ', ' : '、');

/** 接口返回的中文报错：有译文时译成英文，否则原样显示。 */
export const tMessage = (text: string) => t(text);
